import { ReactNode } from "react";
import { isValid } from "date-fns/esm";

import Box from "ds/components/Box";
import Icon, { IconProps } from "ds/components/Icon";
import Typography, { TypographyProps } from "ds/components/Typography";
import { Clock } from "components/icons/generated";
import DesktopView from "components/Mobile/DesktopView";

import Timestamp from ".";

type TimestampMetaInfoProps = {
  icon?: IconProps["src"];
  timestamp: number;
  prefix?: ReactNode;
  postfix?: ReactNode;
  variant?: TypographyProps["variant"];
} & React.HTMLAttributes<HTMLElement>;

const TimestampMetaInfo = ({
  timestamp,
  icon = Clock,
  prefix,
  postfix,
  variant = "p-body3",
  ...props
}: TimestampMetaInfoProps) => {
  if (!isValid(timestamp)) {
    return null;
  }
  return (
    <Typography {...props} variant={variant} tag="div" color="secondary">
      <Box fullWidth gap="small" align="center">
        <Icon color="secondary" src={icon} />
        <Box align="center">
          <DesktopView>
            {prefix}
            {prefix && <span>&nbsp;</span>}
          </DesktopView>
          <Timestamp color="secondary" variant={variant} timestamp={timestamp} />
          {postfix && <span>&nbsp;</span>}
          {postfix}
        </Box>
      </Box>
    </Typography>
  );
};

export default TimestampMetaInfo;
